import * as ROUTES from './Routes'

export default ROUTES
